import { logger } from "@origin-digital/reporting-client";
import { forceUserIntervention } from "./helpers";
import { shouldShowMigratedModal } from "./migrationContext";

export const verifyAppUsers = async () => {
  logger.warn(`[migration-experience] verifyingNativeUsers...`);
  const show = await shouldShowMigratedModal();

  if (show) {
    forceUserIntervention();
  }
};
